import React from 'react';
import PaymentDataView from './views/PaymentDataView';
import { usePaymentData } from './hooks/PaymentData.hook';
import { useSelector } from 'react-redux';

const PaymentDataController = () => {
  const {
    loading,
    error,
    handleSubmit,
    selectedCard,
    showDropdown,
    dropdownRef,
    handleCardSelect,
    toggleDropdown,
    validationSchema,
  } = usePaymentData();

  const languageData = useSelector((state) => state.lenguage?.lang);

  const initialValues = {
    cardHolder: '',
    cardNumber: '',
    expiryDate: '',
    securitycode: '',
    email: '',
    isDefault: false,
  };

  const handleRegister = () => {
    console.log('Redirigiendo a registro...');
  };

  const handleBack = () => {
    window.history.back();
  };

  const onSubmit = async (values) => {
    console.log('estos son los valores: ', values);
    try {
      const storedUser = JSON.parse(localStorage.getItem('user'));
      const paymentData = {
        user_id: storedUser?.user_id,
        payment_method_id: 1,
        details: values.cardHolder,
        token: values.token,
        cardNumber: values.cardNumber,
        customerId: values.customerId,
        email: values.email,
        isDefault: values.isDefault,
      };

      console.log('paymentData FINAL:', paymentData);

      await handleSubmit(paymentData);
    } catch (error) {
      console.error('Error desde controller:', error);
    }
  };

  return (
    <PaymentDataView
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      loading={loading}
      error={error}
      languageData={languageData}
      onBack={handleBack}
      onRegister={handleRegister}
      selectedCard={selectedCard}
      showDropdown={showDropdown}
      dropdownRef={dropdownRef}
      handleCardSelect={handleCardSelect}
      toggleDropdown={toggleDropdown}
    />
  );
};

export default PaymentDataController;
